import { DateTime } from 'luxon'
import { BookingPricingModelType } from 'parkdepot-shared/gql/graphql'
import { checkForDaylightSavingsTime } from '../../../utils/checkForDaylightSavingsTime.utils'

export const generateDailyPriceQueryOptions = (
    lotId: string,
    start: DateTime,
    end: DateTime,
    pricingType: BookingPricingModelType
): {
    variables: {
        lot_id: string
        end_datetime: string
        start_datetime: string
        pricing_type: BookingPricingModelType
    }
    fetchPolicy: 'no-cache'
} => {
    const { start: start_datetime, end: end_datetime } = checkForDaylightSavingsTime(start, end)

    return {
        variables: {
            lot_id: lotId.toUpperCase(),
            end_datetime,
            start_datetime,
            pricing_type: pricingType
        },
        fetchPolicy: 'no-cache'
    }
}
